export enum OpenAIModel {
    GPT3_5Turbo = 'gpt-3.5-turbo',
    GPT4 = 'gpt-4',
    GPT4TurboPreview = 'gpt-4-turbo-preview',
    GPT4Turbo = 'gpt-4-turbo',
    GPT4Omni = 'gpt-4o',
    GPT4OmniMini = 'gpt-4o-mini',
    GPT4_1 = "gpt-4.1",
    GPT4_1Nano = "gpt-4.1-nano",
    GPT4_1Mini = "gpt-4.1-mini",
    o1 = "o1",
    o3Mini = "o3-mini"
}

export const GptModelList = [
    { value: OpenAIModel.GPT3_5Turbo, name: 'GPT-3.5 Turbo' },
    { value: OpenAIModel.GPT4, name: 'GPT-4' },
    { value: OpenAIModel.GPT4TurboPreview, name: 'GPT-4 Turbo (Preview)' },
    { value: OpenAIModel.GPT4Turbo, name: 'GPT-4 Turbo' },
    { value: OpenAIModel.GPT4Omni, name: 'GPT-4o' },
    { value: OpenAIModel.GPT4OmniMini, name: 'GPT-4o Mini' }
];
